<template>
  <div>
    <section-collapseable
      v-if="hasStorageIntegration"
      title="Files"
      :button-text="buttonText"
      hide-button-icon
      @add="openPicker"
      :hide-initial-always="!hasDriveFolder"
    >
      <!-- Google Drive Link -->
      <div
        v-if="hasDriveFolder"
        class="flex flex-vertical-center"
      >
        <a
          class="flex-grow"
          :href="record.document_folder_url"
          target="_blank"
        >
          <span class="flex flex-vertical-center">
            <icon-default icon="google-drive" size="is-small"></icon-default>
            <span class="google_drive_button--label">{{ $utils.truncateString(record.document_folder_name, 16) }}</span>
          </span>
        </a>
      </div>
    </section-collapseable>
    <section-collapseable
      v-else
      title="Files"
    >
      <app-upgrade-required/>
    </section-collapseable>
  </div>
</template>

<script>
import AppUpgradeRequired from "../../../components/app/AppUpgradeRequired.vue";

export default {
  name: "LeadFiles",
  components: {AppUpgradeRequired},
  data() {
    return {
      gapi: window.gapi,
      google: window.google,
      // The Browser API key obtained from the Google API Console.
      // Replace with your own Browser API key, or your own key.
      developerKey: process.env.MIX_GOOGLE_DRIVE_BROWSER_API_KEY,

      // The Client ID obtained from the Google API Console. Replace with your own Client ID.
      clientId: process.env.MIX_GOOGLE_DRIVE_CLIENT_ID,

      // Replace with your own project number from console.developers.google.com.
      // See "Project number" under "IAM & Admin" > "Settings"
      appId: process.env.MIX_GOOGLE_APP_ID,

      // Scope to use to access user's Drive items.
      scope: ['https://www.googleapis.com/auth/drive.file', 'https://www.googleapis.com/auth/drive.appfolder'],

      pickerApiLoaded: false,
      authApiLoaded: false,
      oauthToken: undefined,
    }
  },
  mounted() {
    this.gapi.load('auth', {'callback': this.onAuthApiLoad});
    this.gapi.load('picker', {'callback': this.onPickerApiLoad});
  },
  computed: {
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord.record : {
        document_folder_url: null,
      };
    },
    hasStorageIntegration() {
      return this.$store.state.accounts.features.StorageIntegration;
    },
    hasDriveFolder() {
      return !!this.record.document_folder_url;
    },
    buttonText() {
      if(this.hasDriveFolder) {
        return 'Change Folder';
      } else {
        return 'Connect Google Drive'
      }
    }
  },
  methods: {
    openPicker() {
      if (this.pickerApiLoaded && this.authApiLoaded) {
        if (this.oauthToken) {
          this.createPicker();
        } else {
          this.gapi.auth.authorize(
            {
              client_id: this.clientId,
              scope: this.scope,
              immediate: false
            },
            this.handleAuthResult
          );
        }
      } else {
        if (!this.pickerApiLoaded) {
          console.log('Failed to Load Google Picker Api: ')
        }
        if (!this.authApiLoaded) {
          console.log('Failed to Load Google Auth Api: ')
        }
      }
    },
    onAuthApiLoad() {
      this.authApiLoaded = true;
    },

    onPickerApiLoad() {
      this.pickerApiLoaded = true;
    },

    handleAuthResult(authResult) {
      console.log('Google Oauth Response: ', authResult);
      if (authResult && !authResult.error) {
        this.oauthToken = authResult.access_token;
        this.createPicker();
      } else {
        console.log('Google Oauth Errors: ', authResult);
      }
    },
    // Create and render a Picker object for searching images.
    createPicker() {
      if (this.pickerApiLoaded && this.oauthToken) {
        let docsView = new window.google.picker.DocsView()
          .setIncludeFolders(true)
          .setMimeTypes('application/vnd.google-apps.folder')
          .setSelectFolderEnabled(true);

        let picker = new window.google.picker.PickerBuilder()
          .enableFeature(window.google.picker.Feature.NAV_HIDDEN)
          // .enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED)
          .enableFeature(window.google.picker.Feature.SUPPORT_DRIVES)
          .setAppId(this.appId)
          .setOAuthToken(this.oauthToken)
          .setDeveloperKey(this.developerKey)
          .setCallback(this.folderSelected)
          .addView(docsView)
          .build();
        picker.setVisible(true);
      } else {
        console.log('Trying to create picker when data is not set: ', this.pickerApiLoaded, this.oauthToken);
      }
    },

    // A simple callback implementation.
    folderSelected(data) {
      if (data.action === window.google.picker.Action.PICKED) {
        this.$api.records.updateGoogleDrive({
          id: this.record.id,
          document_folder_url: data.docs[0].url,
          document_folder_name: data.docs[0].name,
        });
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.google_drive_button--label {
  margin-left: 8px;
  font-size: 1.125rem;
}
</style>
